import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, toHandlers as _toHandlers, mergeProps as _mergeProps, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "d-flex" }
const _hoisted_2 = { class: "d-none d-flex@lg" }
const _hoisted_3 = { class: "w-full" }
const _hoisted_4 = {
  key: 0,
  style: {"cursor":"auto"},
  class: "d-flex align-items-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavLink = _resolveComponent("NavLink")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_ListGroupHeader = _resolveComponent("ListGroupHeader")!
  const _component_ListGroupSeparator = _resolveComponent("ListGroupSeparator")!
  const _component_ListItem = _resolveComponent("ListItem")!
  const _component_ListGroup = _resolveComponent("ListGroup")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_ListItemText = _resolveComponent("ListItemText")!
  const _component_ListItemIcon = _resolveComponent("ListItemIcon")!
  const _component_AsideMenu = _resolveComponent("AsideMenu")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Navbar, {
      hasAsideMenu: "",
      isOpenAsideMenu: _ctx.isOpenAsideMenu,
      onToggleOpenAsideMenu: _ctx.toggleOpenAsideMenu
    }, {
      "text-baseline": _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.trans("general.site_baseline")), 1)
      ]),
      nav: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link) => {
          return (_openBlock(), _createBlock(_component_NavLink, {
            key: 'link-' + link.to,
            onClick: ($event: any) => (_ctx.navigateTo(link.to)),
            isActive: _ctx.$route.path === link.to
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(link.text), 1)
            ]),
            _: 2
          }, 1032, ["onClick", "isActive"]))
        }), 128))
      ]),
      "right-section": _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_NavLink, null, {
            default: _withCtx(() => [
              (_ctx.authUser)
                ? (_openBlock(), _createBlock(_component_Dropdown, {
                    key: 0,
                    isOpen: _ctx.isDropdownOpen,
                    "onUpdate:isOpen": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isDropdownOpen) = $event)),
                    align: "right"
                  }, {
                    trigger: _withCtx(({ attributes, listeners }) => [
                      _createVNode(_component_Avatar, _mergeProps({
                        username: _ctx.authUser.username,
                        image: _ctx.imageAvatar,
                        color: _ctx.authUser.color,
                        width: "32",
                        height: "32"
                      }, attributes, _toHandlers(listeners)), null, 16, ["username", "image", "color"])
                    ]),
                    dropdownContentBody: _withCtx(() => [
                      _createVNode(_component_ListGroup, { variants: ['dropdown'] }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ListGroupHeader, { style: {"cursor":"auto"} }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.authUser.email), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ListGroupSeparator),
                          _createVNode(_component_ListItem, {
                            href: _ctx.configurationLink,
                            target: "_blank",
                            style: {"text-decoration":"none"},
                            class: "font-weight-normal"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.trans("general.configuration")), 1)
                            ]),
                            _: 1
                          }, 8, ["href"]),
                          _createVNode(_component_ListItem, { onClick: _ctx.logout }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.trans("general.logout")), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["isOpen"]))
                : (_openBlock(), _createBlock(_component_Button, {
                    key: 1,
                    text: _ctx.trans('general.press_access'),
                    isOutline: "",
                    size: "sm",
                    to: {
                name: 'Access',
              },
                    isLoading: _ctx.isFetchingAuthUser,
                    class: "d-none d-flex@lg"
                  }, null, 8, ["text", "isLoading"]))
            ]),
            _: 1
          }),
          _createElementVNode("template", _hoisted_2, [
            _createVNode(_component_NavLink, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.navigateTo('Search')))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Icon, { name: "search" })
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["isOpenAsideMenu", "onToggleOpenAsideMenu"]),
    _createVNode(_component_AsideMenu, {
      isOpen: _ctx.isOpenAsideMenu,
      "onUpdate:isOpen": _cache[4] || (_cache[4] = ($event: any) => (_ctx.isOpenAsideMenu = false))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ListGroup, {
          size: "lg",
          style: {"width":"100%"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ListGroupHeader, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  (_ctx.authUser)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createVNode(_component_Avatar, {
                          username: _ctx.authUser.username,
                          image: _ctx.imageAvatar,
                          color: _ctx.authUser.color,
                          width: "32",
                          height: "32",
                          class: "mr-md"
                        }, null, 8, ["username", "image", "color"]),
                        _createTextVNode(" " + _toDisplayString(_ctx.authUser.email), 1)
                      ]))
                    : (_openBlock(), _createBlock(_component_Button, {
                        key: 1,
                        text: _ctx.trans('general.press_access'),
                        isOutline: "",
                        variants: ['block'],
                        to: {
                name: 'Access',
              },
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isOpenAsideMenu = false))
                      }, null, 8, ["text"]))
                ])
              ]),
              _: 1
            }),
            (_ctx.authUser)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_ListItem, {
                    href: _ctx.configurationLink,
                    target: "_blank",
                    style: {"text-decoration":"none"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.trans("general.configuration")), 1)
                    ]),
                    _: 1
                  }, 8, ["href"]),
                  _createVNode(_component_ListItem, { onClick: _ctx.logout }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.trans("general.logout")), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ], 64))
              : _createCommentVNode("", true),
            _createVNode(_component_ListGroupSeparator),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link) => {
              return (_openBlock(), _createBlock(_component_ListItem, {
                key: 'listItem-link-' + link.to,
                onClick: ($event: any) => (_ctx.navigateTo(link.to)),
                isActive: _ctx.$route.path === link.to
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ListItemText, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(link.text), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["onClick", "isActive"]))
            }), 128)),
            _createVNode(_component_ListItem, {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.navigateTo('Search')))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ListItemIcon, {
                  name: "search",
                  class: "mr-md"
                }),
                _createVNode(_component_ListItemText, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.trans("general.search")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["isOpen"])
  ]))
}